import React, { useRef, useState } from 'react'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import {
  Card,
  Table,
  Button
} from 'antd'

import { useDeepEffect } from '../../utils/hooks'
import _ from 'lodash'
import CategoryForm from './components/CategoryForm'
import axios from 'axios'

import {
  fetchCategories,
  updateCategory
} from '../../modules/category'

const Category = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})

  const { categories, isLoading } = useSelector(
    (state) => ({
      categories: state.category.categories.data,
      isLoading: state.category.isLoading
    }),
    []
  )
  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchCategories())
    }

    fetch()
  }, [])

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }
  const onCloseModal = async () => {
    await dispatch(fetchCategories())
    await setVisible(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updateCategory(data))
    }
    await dispatch(fetchCategories())
    await setVisible(false)
    await setFormData({})
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: 100,
    },
    {
      title: 'Name Eng',
      dataIndex: 'nameEng',
      key: 'nameEng',
      width: 100,
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
        </span>
      )
    }
  ]

  return (
    <Card
      title="Category">
      <Table
        scroll={{ x: 1000 }}
        loading={isLoading}
        rowKey={(record) => record.id}
        dataSource={categories}
        columns={columns}
      />
      <CategoryForm
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
      />
    </Card>
  )
}

export default compose(
  withApollo
)(Category)